// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/Tabs/RefreshButton/query_profile_professionals.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_Tabs_RefreshButton(
  $patient_id: uuid!
  $dtype: String_comparison_exp
  $past: Boolean
) {
  vaxiom_professional_relationships(
    where: {
      dtype: $dtype
      patient: { _id: { _eq: $patient_id } }
      past: { _eq: $past }
    }
  ) {
    id
    dtype
    past
    employee {
      id
      provider {
        id
        resource_type {
          id
          name
        }
        employee_resource {
          id
          employment_contract {
            id
            organization {
              id
              name
              postal_address {
                id
                address_line1
                city
                state
                zip
              }
            }
            person {
              id
              first_name
              middle_name
              last_name
              title
              greeting
              profile_pic_url
              preferred_contact_methods: contact_method_associations(
                where: { preference: { _is_null: false } }
              ) {
                id
                postal_address {
                  id
                  address_line1
                  city
                  state
                  zip
                }
                phone {
                  id
                  number
                }
                email {
                  id
                  address
                }
              }
            }
          }
        }
      }
    }

    other {
      id
      employee_type {
        id
        name
      }
      person {
        id
        first_name
        middle_name
        last_name
        title
        greeting
        profile_pic_url
        preferred_contact_methods: contact_method_associations(
          where: { preference: { _is_null: false } }
        ) {
          id
          phone {
            id
            number
          }
          email {
            id
            address
          }
        }
      }
      external_office {
        id
        name
        postal_address {
          id
          address_line1
          city
          state
          zip
        }
      }
    }
  }
}

`